import { Breadcrumb } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ReactComponent as CaretRightIcon } from '../../common/images/svg/CaretRight.svg';
import { ReactComponent as HomeIcon } from '../../common/images/svg/Home.svg';
import useResponsive from '../../utils/hooks/useResponsive';
import { CustomButton } from '../button/buttonCustom';

interface CustomBreadCrumbProps {
  breadCrumb: { name: string; path: string }[];
  showHome?: boolean;
}

const CustomBreadCrumb: React.FC<CustomBreadCrumbProps> = ({ breadCrumb, showHome = false }) => {
  const { isTablet } = useResponsive();
  const navigate = useNavigate();
  const items = breadCrumb.map((item, index) => ({
    title: (
      <Link
        to={item.path}
        style={{ fontSize: '12px', color: index === breadCrumb.length - 1 ? 'white' : 'rgba(255, 255, 255, 0.6)' }}
      >
        {item.name}
      </Link>
    ),
    key: index,
  }));
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      {showHome && (
        <CustomButton
          text={"Home"}
          icon={<HomeIcon />}
          width={100}
          height={32}
          onClick={() => navigate('/')}
        />
      )}
      <Breadcrumb separator={<CaretRightIcon />} items={items} />
    </div>
  );
};

export default CustomBreadCrumb;
